import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { clsx } from 'clsx';
import * as React from 'react';
/**
 * Submit button for auth forms
 * Handles loading state
 */
export const AuthSubmitButton = React.forwardRef(({ className, isLoading = false, disabled, children, ...props }, ref) => {
    return (_jsxs("button", { ref: ref, type: "submit", className: clsx('auth-submit-button', className), disabled: disabled || isLoading, ...props, children: [isLoading && _jsx("span", { className: "auth-submit-button-spinner" }), _jsx("span", { className: clsx({ 'auth-submit-button-text--loading': isLoading }), children: children })] }));
});
AuthSubmitButton.displayName = 'AuthSubmitButton';
//# sourceMappingURL=AuthSubmitButton.js.map